import { useEffect, useState, useRef } from 'react';
import { ClearButton, Typeahead } from 'react-bootstrap-typeahead';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import { Form, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import axiosClient from '../../../../../utils/axios';
import { setPostDataAttribute } from '../../../../../redux/slices/lomavisCreator/lomavisCreator';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import './tagger.css';
import { ProductCard } from './sharedComponents';

export const TypeaheadProductSelection = ({
  platform,
  name_key,
  currentTag,
  handleInputChange,
  handleInputBlur,
  textRef,
  selectedCatalog
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const { postData } = useSelector((state: any) => state.lomavisCreator);
  const { instagram_shopping_tags } = useSelector(
    (state: any) => state.lomavisCreator.postData[platform]
  );
  const [searchList, setSearchList] = useState([]); // [ { fb_id: "123", name: "some name" }
  const { instagram_shopping } = useSelector(
    (state: any) => state.lomavisCreator.lomavisCreatorConfig
  );
  let debounceTimeout;

  const [isLoading, setIsLoading] = useState(false);

  const debounceRef = useRef(null); // Ref to hold debounce timeout

  const searchForPlaces = (query) => {
    setIsLoading(true);
    if (debounceRef.current) clearTimeout(debounceRef.current); // Clear the previous timeout
    debounceRef.current = setTimeout(() => {
      const url = instagram_shopping?.products_url;

      const searchUrl =
        `${url}` +
        (query.length > 2 ? `?q=${query}` : '') +
        `&catalog_id=${selectedCatalog?.catalog_id}`;

      axiosClient
        .get(searchUrl)
        .then((res) => {
          const data = res.data.data;

          // Filter out duplicate entries based on fb_id
          const uniqueData = data?.reduce((acc, item) => {
            if (
              !acc.some(
                (existingItem) => existingItem?.product_id === item?.product_id
              )
            ) {
              acc.push(item);
            }
            return acc;
          }, []);
          setSearchList(uniqueData);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching places:', error);
          setSearchList([]);
          setIsLoading(false);
        });
    }, 250); // Adjust debounce time as needed
  };
  return (
    <div>
      <div onBlur={handleInputBlur} className="w-100 ">
        {/* Icon moved to the left */}

        <Typeahead
          // This will make the dropdown go up
          disabled={
            !instagram_shopping?.enabled ||
            !currentTag ||
            !selectedCatalog?.catalog_id
          }
          id="tagged-products"
          labelKey="product_name"
          positionFixed={true}
          minLength={3}
          selected={currentTag?.productInfo ? [currentTag?.productInfo] : []}
          options={searchList}
          placeholder={t('lomavisCreator.additionalOptions.tagProduct')}
          emptyLabel={
            !isLoading && searchList?.length === 0 ? (
              t('lomavisCreator.additionalOptions.noResultsFound')
            ) : isLoading && searchList?.length === 0 ? (
              <div className="w-100 d-flex justify-content-center">
                {' '}
                <Spinner animation="border" size="sm" />
              </div>
            ) : (
              ''
            )
          } // Show only when not loading
          isLoading={isLoading}
          filterBy={() => true}
          onInputChange={(e) => {
            if (e.length > 2) {
              searchForPlaces(e);
            }
          }}
          ref={textRef}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              handleInputBlur();
            }
          }}
          className="border-0 position-relative w-100"
          renderMenuItemChildren={(option, state) => {
            const selectedOption = state?.selected?.[0];
            return (
              <div
                onClick={() => {
                  handleInputChange(option);
                }}
                className={`custom-dropdown-item  ${
                  selectedOption &&
                  selectedOption['product_name'] === option['product_name']
                    ? 'text-primary'
                    : ''
                }`}
              >
                <ProductCard
                  imageUrl={option['image_url']}
                  catalogName={selectedCatalog?.catalog_name}
                  productName={option['product_name']}
                />
              </div>
            );
          }}
          clearButton
        />
      </div>

      {!instagram_shopping?.products_url && (
        <span className="text-muted">
          {t('lomavisCreator.additionalOptions.productSearchNotAvailable')}
        </span>
      )}
    </div>
  );
};
